import React, { useState, useEffect, useContext } from "react";
import MyContext from "../../../../context/MyContext";
import AuthContext from "../../../../context/userAuth.context";
import swal from "sweetalert";
import TickerContext from "../../../../context/ticker";
import Lottie from "react-lottie";
import loader from "../../../../assets/Loader/AssetLoader.json";
import ProjectContext from "../../../../context/ProjectContext";

const UploadedVideo = (props) => {
  const { authenticationData } = useContext(AuthContext);
  const [MyLoader, setMyLoader] = useState(false);

  useEffect(() => {
    let url;
    if (props.TaBName == "UploadGreenScreen") {
      url = authenticationData.ApiBaseURL + "/api/images/GetMyGSVideos";
    } else if (props.TaBName == "Upload") {
      url = authenticationData.ApiBaseURL + "/api/images/GetMyVideos";
    }

    // if (props.UploadedData.length == 0) {
    setMyLoader(true);
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + authData.access_token,
      },
    })
      .then(
        (response) => response.json() // if the response is a JSON object
      )
      .then((success) => {
        let urls = [];
        success.map((val, index) => {
          if (props.TaBName == "UploadGreenScreen") {
            urls.push({
              id: val.id,
              VideoUrl: val.path,
              previewImgUrl: val.previewImagePath,
            });
          } else if (props.TaBName == "Upload") {
            urls.push({
              id: val.id,
              VideoUrl: authenticationData.ApiBaseURL + val.path,
              previewImgUrl:
                authenticationData.ApiBaseURL + val.previewImagePath,
            });
          }
        });
        props.setUploadedData(urls);
        setMyLoader(false);
      })
      .catch((error) => {
        setMyLoader(false);
        console.log(error);
      });
    // }
  }, []);

  return (
    <>
      <div
        className="videotemplate d-flex mt-3 scrollbar style-1"
        style={{ height: "calc(100% - 158px)" }}
      >
        <div className="column1">
          {props.UploadedData.map((data, index) => {
            return (
              index % 2 === 0 && (
                <Uploads
                  UploadedData={props.UploadedData}
                  setUploadedData={props.setUploadedData}
                  key={index}
                  id={data.id}
                  VideoUrl={data.VideoUrl}
                  previewImgPath={data.previewImgUrl}
                />
              )
            );
          })}
        </div>

        <div className="column2">
          {props.UploadedData.map((data, index) => {
            return (
              index % 2 !== 0 && (
                <Uploads
                  UploadedData={props.UploadedData}
                  setUploadedData={props.setUploadedData}
                  key={index}
                  id={data.id}
                  VideoUrl={data.VideoUrl}
                  previewImgPath={data.previewImgUrl}
                />
              )
            );
          })}
        </div>
      </div>
      {MyLoader == true && (
        <Lottie
          options={{ loop: true, autoplay: true, animationData: loader }}
          height={200}
          width={200}
          isStopped={false}
          isPaused={false}
        />
      )}
    </>
  );
};

function getRandomArbitrary(min, max) {
  return parseInt(Math.random() * (max - min) + min);
}
export default UploadedVideo;

const Uploads = (props) => {
  const {
    timelineZoomVal,
    setLayersData,
    LayersData,
    calculateTimeByWidth,
    clone,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    ChangeCount,
    setChangeCount,
    calculateWidthByDuration,
    onePxEquivalent,
    seteditableObject,
    EditorZoom,
  } = useContext(MyContext);

  const { authenticationData } = useContext(AuthContext);

  const { slides, setslides } = useContext(ProjectContext);

  const { TickerPosition } = useContext(TickerContext);

  const [delayHandler, setDelayHandler] = useState(null);
  const [time, settime] = useState();
  const [Duration, setDuration] = useState(null);

  const handleMouseEnter = (event) => {
    setDelayHandler(
      setTimeout(() => {
        event.target.play();
      }, 750)
    );
  };

  const handleMouseLeave = (e) => {
    e.target.pause();
    clearTimeout(delayHandler);
  };

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const storeVideoUrl = (e, previewImgPath) => {
    const _video = document.getElementById("video-" + props.id);
    if (_video) {
      var ratio = (300 / _video.videoWidth) * _video.videoHeight;
    }

    var topIndex = 0;
    let TickPos;
    var typelength = 1;
    var checkKey = 0;
    var canvasHeight =
      document.getElementsByClassName("EditorTrackInner")[0].offsetHeight;
    var CanvasWidth =
      document.getElementsByClassName("EditorTrackInner")[0].offsetWidth;

    let _widthPercentage = 300 / 1024;
    let _heightPercentage = ratio / 593;
    let _width = CanvasWidth * _widthPercentage;
    let _height = canvasHeight * _heightPercentage;

    var top = getRandomArbitrary(0, canvasHeight - _height);
    var left = getRandomArbitrary(0, CanvasWidth - _width);

    let stack = [...UndoLayer];
    let PrevArray = clone(LayersData);

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }

    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }
    var checkVideo = false;
    for (var i = 0; i < LayersData.length; i++) {
      if (LayersData[i].type == "Video") {
        swal("This Slide already Contain a video");
        checkVideo = true;
      }
      if (LayersData[i].Editable === true) {
        LayersData[i].Editable = false;
        LayersData[i].showDiv = false;
      }
      LayersData[i].toolbar = false;
      if (LayersData[i].type === "Video") {
        typelength = typelength + 1;
      }
      if (LayersData[i].key >= checkKey) {
        checkKey = LayersData[i].key;
      }
    }

    if (!checkVideo) {
      // let trans = document.getElementById('tickerHead').style.transform
      // if (trans != "") {
      //     trans = trans.split('(')
      //     trans = trans[1].split(',')
      //     trans = trans[0].split('px')
      //     trans = eval(trans[0]);
      //     TickPos = trans
      // }

      let currentTime = calculateTimeByWidth(TickerPosition);

      //let totalTime = calculateTimeByWidth(Tl_TotalTime.width - TickPos)
      let calc = (Duration * 1000) / onePxEquivalent;
      let totalTime = calculateTimeByWidth(calc);
      let VideoTime = calculateTimeByWidth(calc + TickerPosition);

      let newEntryLayerData = {
        Added: true,
        key: checkKey + 1,
        type: "Video",
        bgColor: "#4caf50",
        Name: `Video-${typelength}`,
        AnimationId: makeid(6),
        canvas: null,
        video: null,
        userFile: "xyz",
        layerIndex: topIndex,
        index: null,
        TimelineZoom: timelineZoomVal,
        duration: totalTime,
        startTime: currentTime,
        endTime: VideoTime,
        volume: 1,
        visible: true,
        OutEffect: "none",
        InEffect: "none",
        EditorZoom: EditorZoom,
        audio_node: null,
        typeIcon: "movie",
        startTransitionWidth: 0,
        startTransitionLeft: 0,
        endTransitionWidth: 0,
        endTransitionLeft: 0,
        url: props.VideoUrl,
        ImageSrc: props.previewImgPath,
        x: left,
        y: top,
        lock: false,
        width: _width,
        height: _height,
        toolbar: true,
        FurtherSetting: false,
        flip: "scaleX(1)",
        opacity: 1,
        originalOpacity: 1,
        layerlock: false,
        opc: 1, //its use for the eye on the timeline wrapper for lock
        hidden: false,
        Editable: true,
        startPositionOnTimeline: TickerPosition,
        player: false,
        rotateAngle: 0,
        InMultiDrag: false,
        showDiv: true,
      };
      newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
        newEntryLayerData.duration
      );
      newEntryLayerData.endTransitionLeft =
        newEntryLayerData.widthOnTimeline -
        newEntryLayerData.endTransitionWidth;
      setLayersData(LayersData.concat(newEntryLayerData));
      seteditableObject({
        showPanel: true,
        editableItem: newEntryLayerData,
      });
      // debugger
      // let change = false;
      // const array = Array.from(slides)
      // for(let i = 0; i < array.length; i++)
      // {
      //     if(array[i].IsActive)
      //     {
      //         array[i].LayerData.push(newEntryLayerData)
      //         change = true;
      //     }
      // }

      // if(change)
      // {
      //     setTimeout(() => {
      //         setslides(array)
      //     }, 7000);

      // }
      setChangeCount(ChangeCount + 1);
    }
  };

  useEffect(() => {
    let video = document.createElement("video");
    video.src = props.VideoUrl;
    video.onloadedmetadata = function () {
      setDuration(video.duration);
      var totalNumberOfSeconds = Math.round(video.duration);
      var hours = parseInt(totalNumberOfSeconds / 3600);
      var minutes = parseInt((totalNumberOfSeconds - hours * 3600) / 60);
      var seconds = Math.floor(
        totalNumberOfSeconds - (hours * 3600 + minutes * 60)
      );
      let result =
        (minutes < 10 ? "0" + minutes : minutes) +
        ":" +
        (seconds < 10 ? "0" + seconds : seconds);
      settime(result);
    };
  }, []);

  const Delete = (VideoId) => {
    swal({
      title: "Really want to delete this video..?",
      buttons: true,
      dangerMode: true,
    }).then((value) => {
      if (value) {
        let authData = JSON.parse(
          localStorage.getItem("animation_studio_2.0_access_token")
        );

        fetch(
          authenticationData.ApiBaseURL +
            `/api/images/DeleteUserVideo?id=${VideoId}`,
          {
            method: "Delete",
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
          .then((response) => response.json())
          .then((res) => {
            if (res == true) {
              const array = Array.from(props.UploadedData);
              let changeArray = array.filter(function (value, index, arr) {
                if (value.id != VideoId) {
                  return value;
                }
              });
              props.setUploadedData(changeArray);
              swal("Excellent", "Video Has Been Deleted", "success");
            }
          })
          .catch((error) => {});
      }
    });
  };

  return (
    <div style={{ position: "relative" }}>
      <div
        className="videoDuration"
        style={{ zIndex: 5 }}
        onClick={(e) => {
          storeVideoUrl(e, props.previewImgPath);
        }}
      >
        <div className="wrapper">
          <span className="videoDurationClass">{time}</span>
        </div>
      </div>
      <div
        onClick={() => Delete(props.id)}
        className="userImgDelete"
        title="Delete Video"
      >
        <span
          className="material-icons"
          style={{ fontSize: "14px", lineHeight: "12px" }}
        >
          delete
        </span>
      </div>
      {/* <div
        style={{
          position: "absolute",
          top: "2px",
          right: "3px",
          zIndex: "1",
          background: "#00000054",
          borderBottomLeftRadius: "10px",
        }}
        onClick={() => Delete(props.id)}
      >
        <span
          className="material-icons-outlined"
          style={{
            color: "#fff",
            left: "1px",
            position: "relative",
            cursor: "pointer",
            zIndex: 9999999
          }}
        >
          delete
        </span>
      </div> */}
      <div className="video-preview">
        {/* {Loader && (
                    <div className="videoLoader">
                        <div className="spinner-grow" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                )} */}
        <video
          className="videoStyle"
          id={"video-" + props.id}
          src={props.VideoUrl}
          type="video/mp4"
          muted
          onMouseOver={handleMouseEnter}
          onMouseOut={handleMouseLeave}
          //onLoadedData={() => { setLoader(false) }}
        />
      </div>
    </div>
  );
};
